import { render, staticRenderFns } from "./DatePickerInput.vue?vue&type=template&id=196cfce2&scoped=true&"
import script from "./DatePickerInput.vue?vue&type=script&lang=js&"
export * from "./DatePickerInput.vue?vue&type=script&lang=js&"
import style0 from "./DatePickerInput.vue?vue&type=style&index=0&id=196cfce2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196cfce2",
  null
  
)

export default component.exports